var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _require = require('../crypto'),
    sha256d = _require.sha256d;

var _require2 = require('./common'),
    verify = _require2.verify;

var _require3 = require('./validation'),
    isValidServerIdentityChainId = _require3.isValidServerIdentityChainId;

var _require4 = require('./constant'),
    VERSION_0 = _require4.VERSION_0;

function getIdentityRootChain(_x, _x2) {
  return _getIdentityRootChain.apply(this, arguments);
}

function _getIdentityRootChain() {
  _getIdentityRootChain = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(cli, rootChainId) {
    var entries, extIds, identityKeys, serverManagementSubchainId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isValidServerIdentityChainId(rootChainId)) {
              _context.next = 2;
              break;
            }

            throw new Error("Invalid root chain id ".concat(rootChainId));

          case 2:
            _context.next = 4;
            return cli.getAllEntriesOfChain(rootChainId);

          case 4:
            entries = _context.sent;
            extIds = entries[0].extIds;

            if (!(!extIds[0].equals(VERSION_0) || extIds[1].toString() !== 'Identity Chain' || extIds.length !== 7)) {
              _context.next = 8;
              break;
            }

            throw new Error('Invalid Root Factom Identity Chain');

          case 8:
            identityKeys = extractIdentityKeys(entries[0]);
            serverManagementSubchainId = extractServerManagementSubchainId(entries, identityKeys);
            return _context.abrupt("return", {
              entries: entries,
              identityKeys: identityKeys,
              serverManagementSubchainId: serverManagementSubchainId
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getIdentityRootChain.apply(this, arguments);
}

function getServerManagementSubchain(_x3, _x4, _x5) {
  return _getServerManagementSubchain.apply(this, arguments);
} /////////////////// Extractors ///////////////////////


function _getServerManagementSubchain() {
  _getServerManagementSubchain = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(cli, serverManagementSubchainId, rootChainId) {
    var entries, extIds;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return cli.getAllEntriesOfChain(serverManagementSubchainId);

          case 2:
            entries = _context2.sent;
            extIds = entries[0].extIds;

            if (!(!extIds[0].equals(VERSION_0) || extIds[1].toString() !== 'Server Management' || extIds.length !== 4)) {
              _context2.next = 6;
              break;
            }

            throw new Error('Invalid Server Management Subchain');

          case 6:
            if (!(rootChainId && rootChainId !== extIds[2].toString('hex'))) {
              _context2.next = 8;
              break;
            }

            throw new Error("This Server Management Subchain' doesnt reference the Identity Root Chain Id provided");

          case 8:
            return _context2.abrupt("return", {
              entries: entries
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getServerManagementSubchain.apply(this, arguments);
}

function extractIdentityKeys(entry) {
  var extIds = entry.extIds;
  return [extIds[2], extIds[3], extIds[4], extIds[5]];
}

function extractServerManagementSubchainId(entries, identityKeys) {
  var serverManagementSubchainEntry = entries.find(function (e) {
    return e.extIds[1].toString() === 'Register Server Management';
  });

  if (!serverManagementSubchainEntry) {
    throw new Error('No Server Managemenet Subchain registering entry found');
  }

  verifyServerManagementSubchainRegistration(serverManagementSubchainEntry, identityKeys[0]);
  return serverManagementSubchainEntry.extIds[2];
}

function verifyServerManagementSubchainRegistration(entry, identityKey1) {
  var extIds = entry.extIds;

  if (!extIds[0].equals(VERSION_0) || extIds[1].toString() !== 'Register Server Management' || extIds[2].length !== 32 || !sha256d(extIds[3]).equals(identityKey1)) {
    throw new Error('Invalid Server Managemenet Subchain registration');
  }

  var data = Buffer.concat(extIds.slice(0, 3));

  if (!verify(extIds[3], data, extIds[4])) {
    throw new Error('Invalid signature of the Server Managemenet Subchain registration');
  }
}

module.exports = {
  getIdentityRootChain: getIdentityRootChain,
  getServerManagementSubchain: getServerManagementSubchain
};